import { render, staticRenderFns } from "./FooterColumn.vue?vue&type=template&id=0e60c920&scoped=true"
import script from "./FooterColumn.vue?vue&type=script&lang=js"
export * from "./FooterColumn.vue?vue&type=script&lang=js"
import style0 from "./FooterColumn.vue?vue&type=style&index=0&id=0e60c920&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e60c920",
  null
  
)

export default component.exports